import { render, staticRenderFns } from "./BaseFontSelect.vue?vue&type=template&id=45b39d12&scoped=true"
import script from "./BaseFontSelect.vue?vue&type=script&lang=js"
export * from "./BaseFontSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseFontSelect.vue?vue&type=style&index=0&id=45b39d12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b39d12",
  null
  
)

export default component.exports